/** Auto from pm.by Relum shadow dump — do not hand-edit amounts; scaled to TRY at runtime */
export const RELUM_HOST_EXTRAS = {
  "setting-background-color": "#2F3037",
  "setting-text-color": "#FFFFFF",
  "card-radius": "24px",
  "level-radius": "12px",
  "game-radius": "12px"
};
export const RELUM_CARDS = [
  {
    "id": "104_1",
    "classes": "logo-half-overlay cursor-pointer",
    "slug": "amusnet",
    "logo": "/static/content/Casino/relum/26ac0c3a-8472-4ee8-a4b9-feb7ead2549c.webp",
    "levels": [
      {
        "index": 0,
        "icon": "/static/content/Casino/relum/Spades.webp",
        "label": "MEGA",
        "amount": 712180.61,
        "currency": "BYN"
      },
      {
        "index": 1,
        "icon": "/static/content/Casino/relum/Hearts.webp",
        "label": "MAJOR",
        "amount": 47645.09,
        "currency": "BYN"
      },
      {
        "index": 2,
        "icon": "/static/content/Casino/relum/Clubs.webp",
        "label": "MINOR",
        "amount": 1276.86,
        "currency": "BYN"
      },
      {
        "index": 3,
        "icon": "/static/content/Casino/relum/Diamonds.webp",
        "label": "MINI",
        "amount": 224.41,
        "currency": "BYN"
      }
    ],
    "total": 761326.97,
    "games": [
      "/static/content/Casino/relum/62f2a073-6383-4a7d-9cea-1b5c70e8cace.webp",
      "/static/content/Casino/relum/1929cd42-515d-4c69-972e-2a3b23e73f2b.webp",
      "/static/content/Casino/relum/015-b9c3d84a-e6b4-4a14-b549-797f5c41ee6c_Shining-Crown-2-.webp",
      "/static/content/Casino/relum/dbae761d-2c44-4913-81bb-465dd82acd9e.webp",
      "/static/content/Casino/relum/4ab6ff22-abed-4f3d-ac0a-17d428d785b6.webp",
      "/static/content/Casino/relum/144be652-4f2b-4ca6-b20d-2764d1362e2b.webp",
      "/static/content/Casino/relum/5fbad542-49d7-439c-9e0e-3c66d19ea52f.webp",
      "/static/content/Casino/relum/03b4234e-123e-448b-9738-e8f1d92f6043.webp",
      "/static/content/Casino/relum/260d5949-f9cf-4123-963e-646abbba9b2c.webp",
      "/static/content/Casino/relum/a1263aa2-138b-4011-9228-245cad4dab24.webp"
    ],
    "vars": {
      "background-color": "linear-gradient(180deg, #65801D 0%, rgba(21, 32, 45, 0) 80%)",
      "border-color": "linear-gradient(180deg, #8DC646 0%, rgba(21, 32, 45, 0) 60%)",
      "level-background-color": "#ffffff0f",
      "level-border-color": "#ffffff0f",
      "divider-color": "#ffffff",
      "secondary-text-color": "rgba(255, 255, 255, 0.6)",
      "text-color": "#ffffff",
      "amount-color": "#ffffff"
    }
  },
  {
    "id": "175_355",
    "classes": "logo-half-overlay cursor-pointer",
    "slug": "pateplay",
    "logo": "/static/content/Casino/relum/b7860b4c-d6f9-402e-9024-eeb04c7ae811.webp",
    "levels": [
      {
        "index": 0,
        "icon": "/static/content/Casino/relum/Spades.webp",
        "label": "RED",
        "amount": 287651.46,
        "currency": "BYN"
      },
      {
        "index": 1,
        "icon": "/static/content/Casino/relum/Hearts.webp",
        "label": "BLUE",
        "amount": 1723.47,
        "currency": "BYN"
      },
      {
        "index": 2,
        "icon": "/static/content/Casino/relum/Clubs.webp",
        "label": "GREEN",
        "amount": 90.99,
        "currency": "BYN"
      },
      {
        "index": 3,
        "icon": "/static/content/Casino/relum/Diamonds.webp",
        "label": "PURPLE",
        "amount": 42.67,
        "currency": "BYN"
      }
    ],
    "total": 289508.59,
    "games": [
      "/static/content/Casino/relum/052-34f90d05-32aa-485b-9618-d344f2664faf_Jester-Bags-BB-1-.webp",
      "/static/content/Casino/relum/053-7ee8ba8f-d286-42aa-af77-6f3cee667b1e_Regal-Spins-10-BB-1-.webp",
      "/static/content/Casino/relum/f75806d8-afe8-41b1-8dfa-a7562323ad47_Pure-Ecstasy.webp",
      "/static/content/Casino/relum/0131a262-37ee-459e-99f0-be479902e64e_Red-27.webp",
      "/static/content/Casino/relum/a59f2d49-3d79-48c1-8496-3c2a948b4825_Bufona-Alegre-10.webp",
      "/static/content/Casino/relum/054-838e2716-bb03-4ac5-afef-b17fd05eed9a_Sevens-Joy-1-.webp",
      "/static/content/Casino/relum/66085d7c-2419-4543-a966-f8bec274a89c_Adamant-Bang-20.webp",
      "/static/content/Casino/relum/7c0e4c43-44b8-45c2-b8f4-0f41a238696d_Sevens-Heat-20.webp",
      "/static/content/Casino/relum/8ab2568a-22b5-42c2-8ab4-b942c58ec798_Noble-Fate-20-3.webp",
      "/static/content/Casino/relum/055-b9482118-e7b0-4148-b4de-e1cf2dfc54d7_Sevens-Play-3-.webp"
    ],
    "vars": {
      "background-color": "linear-gradient(180deg, #720E3D 0%, rgba(21, 32, 45, 0) 80%)",
      "border-color": "linear-gradient(180deg, #C71B6B 0%, rgba(21, 32, 45, 0) 60%)",
      "level-background-color": "#ffffff0f",
      "level-border-color": "#ffffff0f",
      "divider-color": "#ffffff",
      "secondary-text-color": "rgba(255, 255, 255, 0.6)",
      "text-color": "#ffffff",
      "amount-color": "#ffffff"
    }
  },
  {
    "id": "157_106",
    "classes": "logo-half-overlay cursor-pointer",
    "slug": "pragmaticplay",
    "logo": "/static/content/Casino/relum/634f47ec-30b9-4fa8-b4b0-85e44d657f73.webp",
    "levels": [
      {
        "index": 0,
        "icon": "/static/content/Casino/relum/Spades.webp",
        "label": "GRAND",
        "amount": 226993.84,
        "currency": "BYN"
      },
      {
        "index": 1,
        "icon": "/static/content/Casino/relum/Hearts.webp",
        "label": "MEGA",
        "amount": 4061.29,
        "currency": "BYN"
      },
      {
        "index": 2,
        "icon": "/static/content/Casino/relum/Clubs.webp",
        "label": "MAJOR",
        "amount": 39.42,
        "currency": "BYN"
      },
      {
        "index": 3,
        "icon": "/static/content/Casino/relum/Diamonds.webp",
        "label": "MINOR",
        "amount": 79.56,
        "currency": "BYN"
      }
    ],
    "total": 231174.11,
    "games": [
      "/static/content/Casino/relum/060-5d10efc7-5ea4-4d73-893f-69887cc015a2_Kingdom-of-Atlantis-Jackpot-Play-2-.webp",
      "/static/content/Casino/relum/057-42f8ebf3-d8f7-45a2-bb6f-ff46ee149993_Egg-Rush-Jackpot-Play-1-.webp",
      "/static/content/Casino/relum/2afe5441-eb22-4e72-91e5-d4b5821c7b81_287x193.webp",
      "/static/content/Casino/relum/056-3dd6fb1d-f091-4555-8993-51066397532a_Tiki-Hut-Megaways-Jackpot-Play.webp",
      "/static/content/Casino/relum/058-4afcb811-2e36-49e0-8bad-8c35c83a3980_Tropical-Pop-Jackpot-Play.webp",
      "/static/content/Casino/relum/063-e2da3217-fab4-410e-95f3-1799543ac2b4_287x193-5-.webp",
      "/static/content/Casino/relum/059-5742aac6-42f3-44fc-8c2c-3e267fbeff7d_Gameshow-Party-Jackpot-Play-1-.webp",
      "/static/content/Casino/relum/061-553925c0-b676-48fd-a7b9-f927e1d2719d_287x193-2-.webp",
      "/static/content/Casino/relum/062-89500cbd-c4e8-49e0-9a99-dff3c61cbb70_287x193-4-.webp",
      "/static/content/Casino/relum/237cf352-c4fc-492e-875b-e09af9bc5191_287x193.webp"
    ],
    "vars": {
      "background-color": "linear-gradient(180deg, #004781 0%, rgba(21, 32, 45, 0) 80%)",
      "border-color": "linear-gradient(180deg, #1684DE 0%, rgba(21, 32, 45, 0) 60%)",
      "level-background-color": "#ffffff0f",
      "level-border-color": "#ffffff0f",
      "divider-color": "#ffffff",
      "secondary-text-color": "rgba(255, 255, 255, 0.6)",
      "text-color": "#ffffff",
      "amount-color": "#ffffff"
    }
  },
  {
    "id": "174_1",
    "classes": "logo-half-overlay cursor-pointer",
    "slug": "amusnet",
    "logo": "/static/content/Casino/relum/9f1b0deb-beaf-4e29-91c4-594836ac7567.webp",
    "levels": [
      {
        "index": 0,
        "icon": "/static/content/Casino/relum/Spades.webp",
        "label": "GRAND",
        "amount": 130962.43,
        "currency": "BYN"
      },
      {
        "index": 1,
        "icon": "/static/content/Casino/relum/Hearts.webp",
        "label": "MAJOR",
        "amount": 51878.86,
        "currency": "BYN"
      },
      {
        "index": 2,
        "icon": "/static/content/Casino/relum/Clubs.webp",
        "label": "MINOR",
        "amount": 198.0,
        "currency": "BYN"
      },
      {
        "index": 3,
        "icon": "/static/content/Casino/relum/Diamonds.webp",
        "label": "MINI",
        "amount": 38.0,
        "currency": "BYN"
      }
    ],
    "total": 183077.29,
    "games": [
      "/static/content/Casino/relum/017-df17bb48-4200-4bce-b5fa-484a0cc40350_Art-of-Gold-Golden-Coins-Link-1-.webp",
      "/static/content/Casino/relum/d07196a3-a71c-43c0-a7f4-ef201d626e7b_40-Extra-Crown-Classic-Dice-Golden-Coins-Link.webp",
      "/static/content/Casino/relum/016-c7b0d197-efc7-4d54-9b9e-25d06add05ce_100-Bulky-Fruits-Golden-Coins-Link.webp",
      "/static/content/Casino/relum/014-8a1f22e0-4c5b-4c66-808f-cc50868bdc04_40-Power-Hot-Golden-Coins-Link-2-.webp",
      "/static/content/Casino/relum/019-fb2d6733-12ea-4cfd-8214-77604028c28a_100-Bulky-Dice-Golden-Coins-Link-1-.webp",
      "/static/content/Casino/relum/018-f1235872-cf37-49c3-b795-79d2ddde70b7_20-Glossy-Hot-Golden-Coins-Link-1-.webp",
      "/static/content/Casino/relum/345bdacd-1853-46be-aace-dda9d78040ea_40-Art-of-Gold-Dice-Edition-Golden-Coins-Link.webp",
      "/static/content/Casino/relum/013-6fd1e1ba-9755-4bba-9ce5-8c9145ae5c0e_40-Power-Hot-Dice-Edition-Golden-Coins-Link-4-.webp",
      "/static/content/Casino/relum/9387d52a-0e27-4d03-bc93-d50a772f4baf_40-Extra-Crown-Golden-Coins-Link.webp",
      "/static/content/Casino/relum/012-03688a17-d3de-4063-bddd-9b4e40d384c6_40-Mystic-Gem-Golden-Coins-Link-2-.webp"
    ],
    "vars": {
      "background-color": "linear-gradient(180deg, #034A15 0%, rgba(21, 32, 45, 0) 80%)",
      "border-color": "linear-gradient(180deg, #097C1B 0%, rgba(21, 32, 45, 0) 60%)",
      "level-background-color": "#ffffff0f",
      "level-border-color": "#ffffff0f",
      "divider-color": "#ffffff",
      "secondary-text-color": "rgba(255, 255, 255, 0.6)",
      "text-color": "#ffffff",
      "amount-color": "#ffffff"
    }
  },
  {
    "id": "107_399",
    "classes": "logo-half-overlay cursor-pointer",
    "slug": "egtdigital",
    "logo": "/static/content/Casino/relum/cc5a9041-16c7-49cf-bbeb-0ec5f501952f.webp",
    "levels": [
      {
        "index": 0,
        "icon": "/static/content/Casino/relum/Spades.webp",
        "label": "GRAND",
        "amount": 99881.83,
        "currency": "BYN"
      },
      {
        "index": 1,
        "icon": "/static/content/Casino/relum/Hearts.webp",
        "label": "MAJOR",
        "amount": 5631.79,
        "currency": "BYN"
      },
      {
        "index": 2,
        "icon": "/static/content/Casino/relum/Clubs.webp",
        "label": "MINOR",
        "amount": 161.96,
        "currency": "BYN"
      },
      {
        "index": 3,
        "icon": "/static/content/Casino/relum/Diamonds.webp",
        "label": "MINI",
        "amount": 161.51,
        "currency": "BYN"
      }
    ],
    "total": 105837.09,
    "games": [
      "/static/content/Casino/relum/037-c96b682f-22aa-46e8-af44-9e0c9ff8bbb7_Leprechaun-Hot.webp",
      "/static/content/Casino/relum/041-e56d1225-a17f-42cd-87d0-f0674ede3cea_10-Burning-Heart.webp",
      "/static/content/Casino/relum/029-7b686096-ba82-48c0-bc6d-cea2b5091ed0_20-Burning-Hot.webp",
      "/static/content/Casino/relum/024-367970e2-33a5-43b6-9251-6742f5ac5598_Shining-Crown.webp",
      "/static/content/Casino/relum/028-5645355d-014d-492e-ae34-140530a26d3a_Sugar-Duke.webp",
      "/static/content/Casino/relum/020-07a65948-bc5a-4e9d-8f3f-a367b1c21868_40-Charming-Joker.webp",
      "/static/content/Casino/relum/033-b0bffe75-e1e9-4ced-8394-d9eb5cd102e2_40-Mega-Clover.webp",
      "/static/content/Casino/relum/036-c4517b4b-74db-40f1-beca-3a6fdd3e0eac_Sugartime.webp",
      "/static/content/Casino/relum/034-b5de0cf9-bbbf-42b3-9b50-8387b9121e8e_Book-of-Shining-Hot-Jumboways.webp",
      "/static/content/Casino/relum/021-1ae69e5d-fb87-4b3d-af14-938f72f23748_Hermes-Fortunes.webp"
    ],
    "vars": {
      "background-color": "linear-gradient(180deg, #4523C5 0%, rgba(21, 32, 45, 0) 80%)",
      "border-color": "linear-gradient(180deg, #7650FF 0%, rgba(21, 32, 45, 0) 60%)",
      "level-background-color": "#ffffff0f",
      "level-border-color": "#ffffff0f",
      "divider-color": "#ffffff",
      "secondary-text-color": "rgba(255, 255, 255, 0.6)",
      "text-color": "#ffffff",
      "amount-color": "#ffffff"
    }
  },
  {
    "id": "109_399",
    "classes": "logo-half-overlay cursor-pointer",
    "slug": "egtdigital",
    "logo": "/static/content/Casino/relum/0e9b0483-a003-4040-8728-2f9cd1824354.webp",
    "levels": [
      {
        "index": 0,
        "icon": "/static/content/Casino/relum/Spades.webp",
        "label": "GRAND",
        "amount": 100402.75,
        "currency": "BYN"
      },
      {
        "index": 1,
        "icon": "/static/content/Casino/relum/Hearts.webp",
        "label": "MAJOR",
        "amount": 1247.17,
        "currency": "BYN"
      },
      {
        "index": 2,
        "icon": "/static/content/Casino/relum/Clubs.webp",
        "label": "MINOR",
        "amount": 48.0,
        "currency": "BYN"
      },
      {
        "index": 3,
        "icon": "/static/content/Casino/relum/Diamonds.webp",
        "label": "MINI",
        "amount": 8.0,
        "currency": "BYN"
      }
    ],
    "total": 101705.92,
    "games": [
      "/static/content/Casino/relum/027-4d79412d-1905-413e-b8e7-1b3c97493c89_40-Shining-Crown-Bell-Link.webp",
      "/static/content/Casino/relum/038-c9c3b668-1fe5-48c7-b4a3-63da3fa343cb_40-Super-Hot-Bell-Link.webp",
      "/static/content/Casino/relum/030-86fbebd9-f6ca-4617-bfde-e0946a2c71cc_40-Burning-Hot-Bell-Link.webp",
      "/static/content/Casino/relum/022-2c10832a-105b-42ea-9ed6-c44426ca3660_Vampire-Nigh-Bell-Link.webp",
      "/static/content/Casino/relum/039-d448c08d-f460-41b9-921e-5f94c9851e42_Flaming-Hot-Extreme-Bell-Link.webp",
      "/static/content/Casino/relum/042-f02372e7-92a9-4337-a28f-6c4a8396e6d4_40LuckyKingBellLink.webp",
      "/static/content/Casino/relum/043-fdf38842-a05f-48a9-a113-76760852ae2b_40-Zodiac-Wheel-Bell-Link.webp",
      "/static/content/Casino/relum/035-b63341f8-eef3-4ee1-973f-230b32f4938e_40-Super-Fruits-Bell-Link.webp",
      "/static/content/Casino/relum/023-30e94f60-4fa6-4c76-b424-a50ab836907e_Shining-Crown-Bell-Link.webp",
      "/static/content/Casino/relum/040-d9b8dd2d-32de-4a3a-860a-e934eb215acc_40-Lucky-King-Extreme-Bell-Link-1-.webp"
    ],
    "vars": {
      "background-color": "linear-gradient(180deg, #841D00 0%, rgba(21, 32, 45, 0) 80%)",
      "border-color": "linear-gradient(180deg, #F42327 0%, rgba(21, 32, 45, 0) 60%)",
      "level-background-color": "#ffffff0f",
      "level-border-color": "#ffffff0f",
      "divider-color": "#ffffff",
      "secondary-text-color": "rgba(255, 255, 255, 0.6)",
      "text-color": "#ffffff",
      "amount-color": "#ffffff"
    }
  },
  {
    "id": "108_295",
    "classes": "logo-half-overlay cursor-pointer",
    "slug": "egyptquest",
    "logo": "/static/content/Casino/relum/f889120c-ba69-4270-a47e-4a108316e57b.webp",
    "levels": [
      {
        "index": 0,
        "icon": "/static/content/Casino/relum/Spades.webp",
        "label": "PLATINUM",
        "amount": 55895.18,
        "currency": "BYN"
      },
      {
        "index": 1,
        "icon": "/static/content/Casino/relum/Hearts.webp",
        "label": "GOLD",
        "amount": 1396.83,
        "currency": "BYN"
      },
      {
        "index": 2,
        "icon": "/static/content/Casino/relum/Clubs.webp",
        "label": "SILVER",
        "amount": 220.03,
        "currency": "BYN"
      },
      {
        "index": 3,
        "icon": "/static/content/Casino/relum/Diamonds.webp",
        "label": "BRONZE",
        "amount": 28.61,
        "currency": "BYN"
      }
    ],
    "total": 57540.65,
    "games": [
      "/static/content/Casino/relum/048-4821384a-45cf-480d-8fcb-914aaf665842.webp",
      "/static/content/Casino/relum/045-23ef33e5-cce0-4ed3-9f4f-875a917ff655.webp",
      "/static/content/Casino/relum/046-2f51941a-a9ac-4031-bd45-2fb9832a624a.webp",
      "/static/content/Casino/relum/047-3ddea773-27ec-41d8-a878-bbde55de499e_EQ-Egypt-Sky-2-.webp",
      "/static/content/Casino/relum/044-14556407-ee1c-4dab-bc6d-dfa283b046e8.webp",
      "/static/content/Casino/relum/049-657cb4ae-ffe6-4ea1-a04e-26bb90859c20.webp"
    ],
    "vars": {
      "background-color": "linear-gradient(180deg, #825C07 0%, rgba(21, 32, 45, 0) 80%)",
      "border-color": "linear-gradient(180deg, #FFAE00 0%, rgba(21, 32, 45, 0) 60%)",
      "level-background-color": "#ffffff0f",
      "level-border-color": "#ffffff0f",
      "divider-color": "#ffffff",
      "secondary-text-color": "rgba(255, 255, 255, 0.6)",
      "text-color": "#ffffff",
      "amount-color": "#ffffff"
    }
  },
  {
    "id": "162_399",
    "classes": "logo-half-overlay cursor-pointer",
    "slug": "egtdigital",
    "logo": "/static/content/Casino/relum/ac470550-d517-4993-a27c-ceec6c522645.webp",
    "levels": [
      {
        "index": 0,
        "icon": "/static/content/Casino/relum/Spades.webp",
        "label": "GRAND",
        "amount": 23386.8,
        "currency": "BYN"
      },
      {
        "index": 1,
        "icon": "/static/content/Casino/relum/Hearts.webp",
        "label": "MAJOR",
        "amount": 3054.63,
        "currency": "BYN"
      },
      {
        "index": 2,
        "icon": "/static/content/Casino/relum/Clubs.webp",
        "label": "MINOR",
        "amount": 33.0,
        "currency": "BYN"
      },
      {
        "index": 3,
        "icon": "/static/content/Casino/relum/Diamonds.webp",
        "label": "MINI",
        "amount": 16.0,
        "currency": "BYN"
      }
    ],
    "total": 26490.43,
    "games": [
      "/static/content/Casino/relum/032-aa6e0d13-0ec0-40f8-8cdb-f701abae282f_Leprechance-Treasury.webp",
      "/static/content/Casino/relum/025-37b78e06-b832-4c90-b51a-e4eb370e804a_Mummy-Secret.webp",
      "/static/content/Casino/relum/026-3bf58fc9-0bf4-415c-8fa0-9334c10f8ce4_Dragons-Realm.webp",
      "/static/content/Casino/relum/031-913395d6-9627-498f-90a4-5aebe0bf3e33_Princess-Cash.webp"
    ],
    "vars": {
      "background-color": "linear-gradient(180deg, #059EC9 0%, rgba(21, 32, 45, 0) 80%)",
      "border-color": "linear-gradient(180deg, #89E0FF 0%, rgba(21, 32, 45, 0) 60%)",
      "level-background-color": "#ffffff0f",
      "level-border-color": "#ffffff0f",
      "divider-color": "#ffffff",
      "secondary-text-color": "rgba(255, 255, 255, 0.6)",
      "text-color": "#ffffff",
      "amount-color": "#ffffff"
    }
  },
  {
    "id": "213_407",
    "classes": "logo-half-overlay cursor-pointer",
    "slug": "7777gaming",
    "logo": "/static/content/Casino/relum/7199cadf-153c-4860-b860-13cf9fc044b3.webp",
    "levels": [
      {
        "index": 0,
        "icon": "/static/content/Casino/relum/Spades.webp",
        "label": "SEVEN",
        "amount": 16554.38,
        "currency": "BYN"
      },
      {
        "index": 1,
        "icon": "/static/content/Casino/relum/Hearts.webp",
        "label": "WATERMELON",
        "amount": 1235.79,
        "currency": "BYN"
      },
      {
        "index": 2,
        "icon": "/static/content/Casino/relum/Clubs.webp",
        "label": "CHERRY",
        "amount": 86.03,
        "currency": "BYN"
      }
    ],
    "total": 17876.2,
    "games": [
      "/static/content/Casino/relum/003-27e94b5a-b17c-4711-bc31-24183bd4ae3d_Cash-10-Royal-Crown-1-.webp",
      "/static/content/Casino/relum/010-dd652312-66a2-4232-9d52-ca6d82ff2169_King-Cash-10.webp",
      "/static/content/Casino/relum/002-0101f687-c2b2-4027-a7b4-b26ed4f52977_Cash-20-Queen-of-Luck-2-.webp",
      "/static/content/Casino/relum/008-5acd9c4e-e9cf-409c-9b71-9dd0ba842cec_Cash-100.webp",
      "/static/content/Casino/relum/006-3f66379d-687e-49d4-9fa4-0f4dd3674943_Cash-20-Bonus-Clover.webp",
      "/static/content/Casino/relum/004-3442dd10-d4fd-4eab-a935-4f738090dbdd_Cash-50-Royal-Crown.webp",
      "/static/content/Casino/relum/005-382a3f2f-534d-4cd6-8bf3-18e76bd41e96_Star-Signs.webp",
      "/static/content/Casino/relum/011-eca90e5e-4a23-40e8-ab65-ed4951f1beb6_Cash-40.webp",
      "/static/content/Casino/relum/009-69feb872-6408-4b46-afa0-516c3e584928_Cash-100-Lucky-Clover.webp",
      "/static/content/Casino/relum/007-51fb0dc0-5f37-4d0f-aa02-0102174f6026_Cash-20-Lucky-Clover-1-.webp"
    ],
    "vars": {
      "background-color": "linear-gradient(180deg, #570D93 0%, rgba(21, 32, 45, 0) 80%)",
      "border-color": "linear-gradient(180deg, #A123F4 0%, rgba(21, 32, 45, 0) 60%)",
      "level-background-color": "#ffffff0f",
      "level-border-color": "#ffffff0f",
      "divider-color": "#ffffff",
      "secondary-text-color": "rgba(255, 255, 255, 0.6)",
      "text-color": "#ffffff",
      "amount-color": "#ffffff"
    }
  },
  {
    "id": "167_105",
    "classes": "logo-half-overlay cursor-pointer",
    "slug": "endorphina",
    "logo": "/static/content/Casino/relum/d7e82f96-af31-4a73-b4b5-a65617aa01e9.webp",
    "levels": [
      {
        "index": 0,
        "icon": "/static/content/Casino/relum/Spades.webp",
        "label": "GRAND",
        "amount": 10605.92,
        "currency": "BYN"
      },
      {
        "index": 1,
        "icon": "/static/content/Casino/relum/Hearts.webp",
        "label": "MAJOR",
        "amount": 2571.76,
        "currency": "BYN"
      },
      {
        "index": 2,
        "icon": "/static/content/Casino/relum/Clubs.webp",
        "label": "MINOR",
        "amount": 506.96,
        "currency": "BYN"
      }
    ],
    "total": 13684.64,
    "games": [
      "/static/content/Casino/relum/000-b80901c8-10d8-41e9-b63f-0a3011505aa3_LUCKY-CLOVERLAND_11zon.webp",
      "/static/content/Casino/relum/e8fa1e03-cbb2-4cc5-a1ab-c5395f251e17.webp",
      "/static/content/Casino/relum/564f9c6d-35d7-408d-99cf-ae2104f8f491_MongolTreasures.webp",
      "/static/content/Casino/relum/5af32e5f-92a8-4847-8127-392c9e6b7631_emirates2.webp",
      "/static/content/Casino/relum/4db8c8de-e2ee-4366-acfb-9c68b42d8adc_2020HitSlot.webp",
      "/static/content/Casino/relum/050-2ac7354f-bc3e-4b12-b49b-640cf4d9182c_oriental-dragon.webp",
      "/static/content/Casino/relum/17641fe4-44ef-4675-a227-821df80e344c_UltraFresh.webp",
      "/static/content/Casino/relum/180d5275-4a2e-4ffc-afcf-5d6f927c904e_TempleCats.webp",
      "/static/content/Casino/relum/001-de242029-6dbc-4a30-84fc-10684f04d4d7_Lucky-Streak-2.webp",
      "/static/content/Casino/relum/051-abc332cc-09d9-4a48-a955-9ed44996539b_Red-Cap.webp"
    ],
    "vars": {
      "background-color": "linear-gradient(180deg, #082160 0%, rgba(21, 32, 45, 0) 80%)",
      "border-color": "linear-gradient(180deg, #07419E 0%, rgba(21, 32, 45, 0) 60%)",
      "level-background-color": "#ffffff0f",
      "level-border-color": "#ffffff0f",
      "divider-color": "#ffffff",
      "secondary-text-color": "rgba(255, 255, 255, 0.6)",
      "text-color": "#ffffff",
      "amount-color": "#ffffff"
    }
  }
];
export const RELUM_PRIMARY_ID = "104_1";
export const RELUM_PRIMARY_BYN_TOTAL = 761326.97;
